import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import swal from 'sweetalert2';  
import { Router } from '@angular/router';

@Component({
  selector: 'app-nuevocliente',
  templateUrl: './nuevocliente.component.html',
  styleUrls: ['./nuevocliente.component.scss']
})
export class NuevoclienteComponent implements OnInit {
  fecha;
  nombre;
  mes(m){
    var mes =[ "","Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
    return mes[m];
  }
  constructor(
    public authService: AuthService,public router:Router) { }
  id_cliente;
  facturas;
  bndbtn_ed;
  ngOnInit() {
    const day =   new Date().getDay();
    const month =   new Date().getMonth();
    const year =   new Date().getFullYear();
    this.fecha=day+" de "+this.mes(month)+" de  "+year;
    this.nombre=localStorage.getItem("nombre");
    this.id_cliente=localStorage.getItem("cliente");
    try {
      this.facturas=localStorage.getItem("facturas");  
    } catch (error) {
      this.facturas=0;
    }
    this.secc_(1);
    this.bndbtn_ed=false;
  }
  valida_cliente(){
    return true
  }
  edita_resp(itm){}
  nvo_resp(){}
  bndNvoREsp;
  responsables;
  eli_resp(itm){}
  fn_gda_cliente(){
    if(this.valida_cliente()==true){
      let postData={
        id_cliente:0,
        nombre:this.preventa.nombre,
        paterno:this.preventa.paterno,
        materno:this.preventa.materno,
        razonsocial:this.preventa.rs,
        rfc:this.preventa.rfc,
        correo:this.preventa.correo,
        telefono:this.preventa.tel1,
        telefono2:this.preventa.tel2,
        cargo:this.preventa.cargo,
        ext1:this.preventa.ext1,
        ext2:this.preventa.ext2,
        pais:this.preventa.pais,
        estado:this.preventa.estado,
        municipio:this.preventa.municipio,
        colonia:this.preventa.colonia,
        calle:this.preventa.calle,
        cp:this.preventa.cp,
        medio:this.preventa.medio
      };
      console.log(postData)
      this.authService.service("/api/gda_cliente_id_cliente",postData)
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            
            let postDatapms={
              id_usuario:localStorage.getItem("usuario"),
              id_cliente:res.insertId
            }
            console.log
            this.authService.service("/api/gda_pms",postDatapms)
            .then(
              data => {
               this.router.navigate(["/cliente"])
              },
              error => {
                  var de= JSON.stringify(error);
                  var di = JSON.parse(de)
                  swal.fire('¡API incorrecta! PMS ', '', 'error');
              });   
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   

    }
  }
  reg_(){
    this.router.navigate(["/lista_cliente"])
  }
  bdn_edit;
  secc;
  preventa={
    id:0,
    nombre:"",
    paterno:"",
    materno:"",
    cargo:"",
    rs:"",
    rfc:"",
    correo:"",
    tel1:"",
    tel2:"",
    ext1:"",
    ext2:"",
    pais:"",
    estado:"",
    municipio:"",
    colonia:"",
    calle:"",
    cp:"",
    medio:""
  }
  limpia_form(){
    this.preventa.id=0;
    this.preventa.nombre="";
    this.preventa.paterno="";
    this.preventa.materno="";
    this.preventa.cargo=""
    this.preventa.rs="";
    this.preventa.rfc="";
    this.preventa.correo="";
    this.preventa.tel1="";
    this.preventa.tel2="";
    this.preventa.ext1="";
    this.preventa.ext2="";
    this.preventa.pais="";
    this.preventa.estado="";
    this.preventa.municipio="";
    this.preventa.colonia="";
    this.preventa.calle="";
    this.preventa.cp="";
    this.preventa.medio="";
  }
  secc_(c){
    this.secc=c;
    switch (c) {
      case 1:
        this.bdn_edit=0;
        this.limpia_form();        
        break;
      default:
        break;
    }
  }
}
